import get from 'lodash/get';
import { ContentAlignment, TableColumn, ColumnDef } from '../..';
import { CellTypeStrategy, getDefaultColumnDefParamsType } from '../models';
import { toBoolean } from './utils';
import { DEFAULT_EMPTY_CELL_PLACEHOLDER } from '../../constants';

export class BooleanCell<TData> implements CellTypeStrategy<TData> {
  public getDefaultColumnDef({
    col,
    isClientSideData,
    metadata,
  }: getDefaultColumnDefParamsType<TData>): Partial<ColumnDef<TData>> {
    return {
      valueFormatter: param => {
        const value = get(param, 'value');
        return value != null ? String(toBoolean(value)) : DEFAULT_EMPTY_CELL_PLACEHOLDER;
      },
      width: 80,
      sortable: isClientSideData,
      // meta: {
      //   align: ContentAlignment.LEFT,
      // },
    };
  }
}
